import React from "react";
import { matchRoutes, useNavigate } from "react-router";
import { router } from "@/app/router";

type IFrameMessageEventType = {
  type?: string;
  path?: string;
};

export function RouteRestore() {
  const navigate = useNavigate();

  const handleMessage = React.useCallback(
    (e: MessageEvent<IFrameMessageEventType>) => {
      if (e.data?.type && e.data.type === "PATH") {
        if (e.data.path) {
          const path = e.data.path.replace(/^#/, "");

          const match = matchRoutes(router.routes, path);
          const leaf = match?.at(-1)?.route;
          const exists = leaf?.path !== "/*";

          if (exists || path === window.location.pathname) {
            void navigate(path.replace("#", ""));
          }
        }
      }
    },
    [navigate],
  );

  React.useLayoutEffect(() => {
    if (window.self !== window.top) {
      window.addEventListener("message", handleMessage);
      window.parent.postMessage({ type: "REQUEST_PATH" }, "*");
    }

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);
  return null;
}
